<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" />
                <div class="page-block">
                    <technical-management-tabs :step="2" :domain="domain" :service="firstServiceForDomain" />

                    <domain-overview
                        v-if="service"
                        :domain="domain"
                        :subscription="service"
                        :nameservers="nameservers"
                        :nameservergroup="nameservergroup"
                        :dnssecKeys="dnssecKeys"
                        :whoisData="whois"
                    />
                    <div v-else class="page-block__item-wrapper">
                        {{ trans('domain.no-domain') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apiMixin } from 'relapp-api';
import { DomainOverview } from 'relapp-domain';
import {
    HeaderPartial,
    serviceMixin,
    servicesPageMixin,
    DnssecApi,
    NameserverApi,
    WhoisApi
} from 'relapp-technical-management';
import { mapGetters } from 'vuex';

export default {
    components: {
        HeaderPartial,
        DomainOverview
    },
    mixins: [apiMixin, serviceMixin, servicesPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'extension'
        };
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.domain.title', { domain: this.domain })
        };
    },
    computed: {
        ...mapGetters({
            dnssecKeys: 'dnssec/dnssecKeys',
            nameservers: 'nameservers/items',
            nameservergroup: 'nameservers/nameserverGroup',
            whoisData: 'whois/whois'
        }),
        /**
         * Get the whois for a domain.
         *
         * @return {object}
         */
        whois() {
            if (this.domain) {
                return this.whoisData[this.domain];
            }
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getAllData();
    },
    methods: {
        /**
         * Get all data for this page.
         */
        getAllData() {
            this.getServices();
            if (this.service) {
                DnssecApi.get(this.routeParams);
                WhoisApi.get(this.domain);
                NameserverApi.get(this.routeParams);
            }
        }
    }
};
</script>
